var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.breakpoints),function(breakpoint){return _c('div',{staticClass:"device",class:_vm.buildViewportClass(breakpoint),attrs:{"id":breakpoint}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }